const asr= "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Ece/faculties/teachingfac/ASR.webp"
export const rti_data=[
    {
        'id':1,
        'program':'RTI Officers',
        'pdf':'https://drive.google.com/file/d/1fEI7j2Ok3m1fsKhk5bcugLiOIR9kJSoF/view?usp=sharing',
    },
    {
        'id':2,
        'program':'TN Information Commission Appeal Rules',
        'pdf':'https://drive.google.com/file/d/1u1XyPumA3k2WzZMfXFtcRldeDs2SsiZN/view?,usp=sharing',
    },
    {
        'id':3,
        'program':'High Court Fee Rules',
        'pdf':'https://drive.google.com/file/d/1mGbEkTBzfyXuGW0CmlDJF2-4vk40DeCr/view?usp=sharing',
    },
    {
        'id':4,
        'program':'Assembly Secretarit Fee Rules',
        'pdf':'https://drive.google.com/file/d/1G8PPYdMyLKuF71UCdpKa_2UELU4dx8xN/view?usp=sharing',
    },
    {
        'id':5,
        'program':'RTI Fee Head Of Account',
        'pdf':'https://drive.google.com/file/d/1xukqjXSKLChnVtRD6-NiSfrKUmYRyPVf/view?usp=sharing',
    },
    {
        'id':6,
        'program':'TN RTI Fee Rules',
        'pdf':'https://drive.google.com/file/d/18yrf_F1AUKd9P-mzLwRTzzTBWiNAzj7u/view?usp=sharing',
    },
    {
        'id':7,
        'program':'RTI Act',
        'pdf':'https://drive.google.com/file/d/13oIIGDWWoAUapi-qTOXY0VJOAMP13UNf/view?usp=sharing',
    },
    {
        'id':8,
        'program':'RTI Guidelines In Tamil',
        'pdf':'https://drive.google.com/file/d/1ZBDpZtrYe36a4pNSwqRmQAPUIsE9u9nI/view?usp=sharing',
    },
];

